import React from "react";

export default function Synonyms(props) {
  //recieve synonyms from Meaning
  // to see whts going on on props, check out console.log(props.synonyms);
  if (props.synonyms.length !== 0) {
    //if synonyms is not empty

    return (
      <div className="Synonyms mt-1 ps-4">
        <span className="d-inline">
          <b>Synonyms:</b>
        </span>
        <ul className="tag-list-synonyms d-flex flex-wrap">
          {props.synonyms.map(function (synonym, index) {
            return <li key={index}>{synonym}</li>;
          })}
        </ul>
      </div>
    );
  }
}
